export default class AutoScroll {
  constructor() {
    this.speed = 0;
    this.animationId = null;
    this.lastTime = 0;
  }

  setSpeed(level) {
    const speeds = [0, 50, 100, 200];
    this.speed = speeds[level] || 0;

    if (this.speed === 0) {
      if (this.animationId) cancelAnimationFrame(this.animationId);
      this.animationId = null;
      return;
    }

    if (!this.animationId) this.start();
  }

  start() {
    this.lastTime = 0;
    const step = (ts) => {
      if (!this.speed) return;
      if (!this.lastTime) this.lastTime = ts;
      const delta = (ts - this.lastTime) / 1000;
      this.lastTime = ts;

      window.scrollBy(0, this.speed * delta);
      const atBottom = window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 1;
      
      if (atBottom) {
        cancelAnimationFrame(this.animationId);
        this.animationId = null;
        return;
      }
      this.animationId = requestAnimationFrame(step);
    };

    this.animationId = requestAnimationFrame(step);
  }
}
